import SparkMD5 from 'spark-md5'
import { Label } from './types'

export const TAB_KEY_CODE = 9
export const ESC_KEY_CODE = 27
export const ENTER_KEY_CODE = 13

export function chunkArray<T>(array: T[], size: number): T[][] {
  const result = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }
  return result
}

export function getLabelsFromFilename(
  filename: string,
  labels: Label[]
): string[] {
  return labels
    .filter((l) => filename.includes(l.name))
    .map((l) => l.systemName)
}

export async function getFileMd5(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      if (!e.target || !e.target.result) return
      resolve(SparkMD5.ArrayBuffer.hash(e.target.result as ArrayBuffer))
    }
    reader.readAsArrayBuffer(file)
  })
}

export function hexToBase64(input: string) {
  // Client side implementation of:
  // Buffer.from(input, 'hex').toString('base64')
  const match = input.match(/\w{2}/g)
  if (match) {
    return btoa(match.map((a) => String.fromCharCode(parseInt(a, 16))).join(''))
  }
  return null
}

export async function getLabelsFromXMP(
  file: File,
  preDefinedLabels: Label[]
): Promise<string[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        if (!e.target || !e.target.result) {
          reject('No result')
          return
        }

        const result = e.target.result as string
        const start = result.indexOf('<x:xmpmeta')
        const end = result.indexOf('</x:xmpmeta>')
        let xmlString = result.slice(start, end)
        xmlString = xmlString + '</x:xmpmeta>'

        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(xmlString, 'text/html')
        const subject = xmlDoc.getElementsByTagName('dc:subject')[0]
        const listItems = subject.getElementsByTagName('rdf:li')

        const labels: string[] = []
        for (let i = 0; i < listItems.length; i++) {
          const label = listItems[i].textContent
          if (label) {
            const inPreDefined = preDefinedLabels.find(
              ({ name }) => name === label.toLowerCase()
            )
            if (inPreDefined && !labels.includes(inPreDefined.systemName)) {
              labels.push(inPreDefined.systemName)
            }
          }
        }

        resolve(labels)
      } catch (err) {
        // If this catches, it most likely means that an image without XMP was added.
        reject(err)
      }
    }

    reader.onerror = (e) => {
      reject(e)
    }

    reader.readAsText(file)
  })
}
